import React, { useContext, } from 'react'
import Modal from 'react-bootstrap/Modal';
import ModalBody from 'react-bootstrap/ModalBody';
import context from '../../context'
import { showLoading } from 'view/component/Alert';

const SubClinic = ({
  show,
  data,
  setModalShow,
  setSelectedData,
  modifyClinicInfo
}) => {
  const patientContext = useContext(context);
  const { clinic = {} } = data;
  const lists = clinic.child || [];

  const modifyData = clinicParam => {
    showLoading('Sedang Di Proses')
    data.clinic = clinicParam;
    data.clinic_id = clinicParam.clinic_id
    modifyClinicInfo(clinicParam);
    setSelectedData({ ...patientContext, ...data });
    setModalShow(false);
  };

  return (
    <Modal show={ show } onHide={ () => setModalShow(false) }>
      <ModalBody>
        {lists.map((list, i) => {
          return (
            <div className='card' onClick={ () => modifyData(list) } key={ i }>
              <div className='card-body rounded bg-success'>
                <h2 className='text-white'>{list.name}</h2>
              </div>
            </div>
          );
        })}
      </ModalBody>
    </Modal>
  );
};

export default SubClinic;